import { CloseOutlined } from '@ant-design/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { INewInfoModalProps } from '@mm/state/modules/modalsState/props';
import classNames from 'classnames';
import React from 'react';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import styles from './NewInfoModal.module.css';

export const NewInfoModal = (props: INewInfoModalProps) => {
  const { onClose, image, title, onClick, button, css, description } = props;
  const { closeModal } = useModalActions();

  const close = async () => {
    await onClose?.();
    closeModal();
  };
  return (
    <div className={classNames(styles.container, css?.container)}>
      <CloseOutlined className={styles.closeIcon} onClick={close} />
      {image && <img src={image} className={css?.image} />}

      <div className={classNames(styles.title, css?.title)}>
        {title}
        <div className={classNames(styles.description, css?.description)}>
          {description}
        </div>
      </div>

      <PrimaryButton
        onClick={() => (onClick ? onClick() : closeModal())}
        className={classNames(styles.button, css?.button)}
      >
        {button}
      </PrimaryButton>
    </div>
  );
};
